import * as React from "react";

import { DEFAULT_THEME_COLOR } from "../constants/index";

export type SvgProps = {
  style?: React.CSSProperties;
  className?: string;
  backgroundColor?: string;
  onClick?(e: React.MouseEvent<SVGElement>): void;
};

export type SvgIconProps<T = {}> = T &
  SvgProps & {
    size?: number;
    color?: string;
  };

const DEFAULT_SIZE: number = 21;
const DEFAULT_COLOR: string = DEFAULT_THEME_COLOR;

export abstract class Svg<TExtraProps = {}> extends React.PureComponent<
  SvgIconProps<TExtraProps>
> {
  protected abstract renderSvg(size: number, color: string): React.ReactNode;

  public render() {
    const { size, color } = this.props;

    return this.renderSvg(
      (size as number) || DEFAULT_SIZE,
      (color as string) || DEFAULT_COLOR
    );
  }
}
